import React from "react";
import { SPCardIcon } from "../../svgs/SPCardIcon";

interface IProps {
  title: string;
  totalCount: number;
  todayCount: number;
}

const SPClaimsDashboardCard: React.FC<IProps> = ({
  title,
  totalCount = 0,
  todayCount = 0
}) => {
  return (
    <div className="rounded-[8px] drop-shadow bg-[#fff] w-full h-full p-4 mb-2">
      <div className="flex items-center px-4 my-auto h-full">
        <div>
          <SPCardIcon />
        </div>
        <div className="ml-4">
          <p className="text-[#324705] text-[16px] font-[500]">{title}</p>
          <p className="text-[#324705] text-[40px] font-[600]">{totalCount}</p>
          <p className="text-[#34623F] text-[16px] font-[500]">{`${todayCount} claimed today`}</p>
        </div>
      </div>
    </div>
  );
};

export default SPClaimsDashboardCard;
